const {
    REACT_APP_DEBUG = 'false',
    REACT_APP_MARKETING_API_BASE_URL,
    REACT_APP_MYEDUPLUS_API_BASE_URL,
    REACT_APP_RECAPTHCA_KEY = '',
    REACT_APP_GOOGLE_TAG_MANAGER_ID = '',
    REACT_APP_CAMPAIGN_NAME = '',
} = process.env;

export const DEBUG = REACT_APP_DEBUG === 'true';
export const MARKETING_API_BASE_URL = REACT_APP_MARKETING_API_BASE_URL;
export const MYEDUPLUS_API_BASE_URL = REACT_APP_MYEDUPLUS_API_BASE_URL;
export const RECAPTHCA_KEY = REACT_APP_RECAPTHCA_KEY;
export const GOOGLE_TAG_MANAGER_ID = REACT_APP_GOOGLE_TAG_MANAGER_ID;
export const CAMPAIGN_NAME = REACT_APP_CAMPAIGN_NAME;